import createReactComponent from '../createReactComponent';
export default createReactComponent('layers-one', 'LayersOne', [["path",{"d":"m12 16 9-4-9-4-9 4z","key":"svg-0"}]]);